/**
 * Whether an API base URI points at a local/dev host.
 * Used to choose the direct Benutzerwechsel path (no email 2FA).
 * Backend still rejects direct swap unless KIENE_DB_PROFILE starts with `dev_`.
 * Parity with mobileapp/utils/isLocalApiBaseUri.ts.
 */
export function isLocalApiBaseUri(baseUri: string): boolean {
    try {
        const raw = (baseUri ?? '').trim();
        if (!raw) {
            return false;
        }
        const withScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(raw) ? raw : `http://${raw}`;
        // Browsers may keep brackets on IPv6 hostnames (`[::1]`).
        const host = new URL(withScheme).hostname.toLowerCase().replace(/^\[|\]$/g, '');
        if (!host) {
            return false;
        }
        if (host === 'localhost' || host === '127.0.0.1' || host === '::1') {
            return true;
        }
        if (host === 'host.docker.internal') {
            return true;
        }
        if (host.endsWith('.local')) {
            return true;
        }
        if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) {
            return true;
        }
        if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(host)) {
            return true;
        }
        const m = /^172\.(\d{1,3})\.\d{1,3}\.\d{1,3}$/.exec(host);
        if (m) {
            const second = Number(m[1]);
            if (second >= 16 && second <= 31) {
                return true;
            }
        }
        return false;
    } catch {
        return false;
    }
}
